import { mapPaginatorData } from '@/framework/utils/data-mappers';
import type { QueryOptions, Section, SectionPaginator } from '@/types';
import { useRouter } from 'next/router';
import { useInfiniteQuery } from 'react-query';
import client from './client';
import { API_ENDPOINTS } from './client/api-endpoints';

export function useSections(options?: Partial<QueryOptions>) {
  const { locale } = useRouter();
  const formattedOptions = {
    ...options,
    language: 'en',
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
  } = useInfiniteQuery<SectionPaginator, Error>(
    [API_ENDPOINTS.HOMEPAGE_SECTION, formattedOptions],
    ({ queryKey, pageParam = 1 }) =>
      client.sections.all(Object.assign({}, queryKey[1], { page: pageParam })),
    {
      getNextPageParam: ({ current_page, last_page }) =>
        last_page > current_page && { page: current_page + 1 },
    },
  );

  function handleLoadMore() {
    fetchNextPage();
  }

  return {
    data: data?.pages?.flatMap((page) => page.data) ?? [],
    paginatorInfo: Array.isArray(data?.pages)
      ? mapPaginatorData(data?.pages[data.pages.length - 1])
      : null,
    isLoading,
    error,
    isFetching,
    isLoadingMore: isFetchingNextPage,
    loadMore: handleLoadMore,
    hasMore: Boolean(hasNextPage),
  };
}
